import { FC, useState, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from 'styles/components/template.module.scss'
import PageHedding from 'components/PageHedding/PageHedding'
import InputTextWithLightLabel from 'components/Form/WithLightLabel/InputText'
import SubmitButton from 'components/Button/SubmitButton'
import Table, { TableBody } from 'components/Table/Table'
import {
  clearDough,
  getDoughById,
  getDoughs,
  DoughType,
} from 'reducks/dough/slice'
import { RootState } from 'reducks/reducers'

const BreadDashBoardTemplate: FC = () => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname
  const [doughList, setDoughList] = useState<TableBody[][]>([])
  const [searchWord, setSearchWord] = useState<string>('')

  const handleSearchWord = (searchWord: string) => {
    setSearchWord(searchWord)
    filter({ inputSearchWord: searchWord })
  }

  const { doughs } = useSelector((state: RootState) => state.doughSlice)
  const { staff } = useSelector((state: RootState) => state.staffSlice)
  const dispatchGetmaterials = useCallback(async () => {
    if (!staff) {
      navigate('/initload?path=' + path)
      window.scrollTo(0, 0)
      return
    }
    const doughs = await dispatch(getDoughs())
    createDoughList(doughs.payload)
  }, [dispatch])
  const createDoughList = useCallback(
    async (doughs: DoughType[]) => {
      const doughList: TableBody[][] = []
      doughs.forEach((dough) => {
        doughList.push([
          {
            category: 'long_name',
            active: true,
            elementInfo: {
              text: {
                label: dough.pettern_name,
              },
            },
          },
          {
            category: 'status',
            active: true,
            elementInfo: {
              status: {
                name: dough.is_disabled ? '使用不可' : '使用可能',
                color: dough.is_disabled ? 'gray' : 'red',
              },
            },
          },
          {
            category: 'icon',
            active: true,
            elementInfo: {
              button: {
                label: '',
                color: 'white',
                size: 'icon',
                icon: 'edit_gray',
                to: '/dough/edit/' + dough.id,
              },
            },
          },
          {
            category: 'icon',
            active: true,
            elementInfo: {
              button: {
                label: '',
                color: 'white',
                size: 'icon',
                icon: 'copy_gray',
                to: '/dough/copy/' + dough.id,
              },
            },
          },
          // {
          //   category: 'icon',
          //   elementInfo: {
          //     button: {
          //       label: '',
          //       color: 'white',
          //       size: 'icon',
          //       icon: 'delete_gray',
          //     },
          //   },
          // },
        ])
      })
      setDoughList(doughList)
    },
    [doughs],
  )

  useEffect(() => {
    dispatchGetmaterials()
  }, [])

  const filter = (payload: { inputSearchWord: string }) => {
    let newDoughs = [...doughs]
    let newSearchWord = payload.inputSearchWord
    if (newSearchWord) {
      newDoughs = newDoughs.filter(
        (dough) =>
          dough.pettern_name
            .replace(/\s+/g, '')
            .toLowerCase()
            .indexOf(newSearchWord.replace(/\s+/g, '').toLowerCase()) > -1,
      )
    }
    createDoughList(newDoughs)
  }

  const handleSubmmit = async (to: string | undefined) => {
    if (to) {
      const id = to.split('/dough/edit/')[1]
        ? to.split('/dough/edit/')[1]
        : to.split('/dough/copy/')[1]
        ? to.split('/dough/copy/')[1]
        : null
      if (id) {
        await dispatch(getDoughById({ id: id }))
        navigate(to)
      }
    }
  }

  const toAddPage = async () => {
    await dispatch(clearDough())
    navigate('/dough/add')
  }

  return (
    <div className={styles.container}>
      <PageHedding title="生地パターン" to="" />
      <div className={styles.pattern}>
        <div className={styles.pattern_head}>
          <InputTextWithLightLabel
            labelName="フリーワード検索"
            description=""
            line={1}
            type="text"
            size="xlarge2"
            value={searchWord}
            placeholder="検索ワードを入力"
            onChange={(event) => handleSearchWord(event.target.value)}
          />
          <SubmitButton
            label="パターンを登録する"
            color="orange"
            size="xlarge"
            icon="plus"
            onClick={() => toAddPage()}
          />
        </div>
        <div className={styles.pattern_table}>
          <Table
            headers={[
              {
                category: 'long_name',
                elementInfo: {
                  text: {
                    label: '生地パターン名',
                  },
                },
              },
              {
                category: 'status',
                elementInfo: {
                  text: {
                    label: '使用可/不可',
                  },
                },
              },
              {
                category: 'icon',
                elementInfo: {
                  text: {
                    label: '編集',
                  },
                },
              },
              {
                category: 'icon',
                elementInfo: {
                  text: {
                    label: '複製',
                  },
                },
              },
              // {
              //   category: 'icon',
              //   elementInfo: {
              //     text: {
              //       label: '削除',
              //     },
              //   },
              // },
            ]}
            bodies={doughList}
            handleSubmmit={handleSubmmit}
          />
        </div>
      </div>
    </div>
  )
}

export default BreadDashBoardTemplate
